import React, { useState } from 'react'
import { createTransaction } from '../../adapters/transaction';
import config from '../../config';
import { casePaymentRequest } from '../../requests/payment';
import useStore from '../../store/index'
import SuccessStatus, { ErrorStatus } from '../FormStatus';
import { FileInput, SelectOptionField } from '../Input';

export default function PaymentModal({ caseData, onClose }) {

    const paymentAccounts = useStore((state) => state.accounts)
    const [selectedAccount, setSelectedAccount] = useState('bank transfer');
    const [selectedCurrency, setSelectedCurrency] = useState('USD');
    const [reciept, setReciept] = useState(null)
    const [errors, setErrors] = useState([]);
    const [formState, setFormState ] = useState({
        status: false,
        message: ''
    })

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            paymentType: selectedAccount,
            currency: selectedCurrency,
            amount: config.RESOLUTION_AMOUNT,
            caseId: caseData._id
        }
        await casePaymentRequest.validate(data).then( async () => {
            try {
                data['reciept'] = reciept
                await createTransaction(data).then((res) => {
                    if(res.status === 200){
                        setFormState({
                            status: true,
                            message: 'Payment reciept was uploaded successfully. And is been confirm'
                        })
                        setTimeout(() => {
                            onClose();
                        }, 4000)
                    }else{
                        setErrors(['Failed to upload reciept'])
                    }
                })
            } catch (e) {
                setErrors(['Failed to upload reciept'])
            }
        }).catch((err) => {
            setErrors(err.errors);
        })
    };
    
  return (
      <div className="fixed z-50 animate__animated animate__fadeIn w-screen h-screen modal-dialog-bg-dark shadow-md md:px-8 px-4 left-0 top-0">
            <div className="relative w-full flex h-full justify-center items-center">
                <div className="lg:w-2/5 relative mt-8 px-8 w-full bg-white py-8 rounded-xl">
                    <h4 className="mb-3 text-sm font-semibold">
                        Resolution Payment
                    </h4>
                    <div className="mt-3">
                        <ErrorStatus errors={errors} />
                        <SuccessStatus message={formState.message} showStatus={formState.status} />
                        <form onSubmit={handleSubmit}>
                            <SelectOptionField label="Select Payment Type" isRequired={true} id="payment-type" defaultValue={selectedAccount} onChange={(e) => {
                                setErrors([]);
                                setSelectedAccount(e.target.value)
                            }} options={Array.from(Object.keys(paymentAccounts['accounts'])).map((pa) => pa)} />


                            {(selectedAccount !== '' && selectedAccount  === 'bank transfer') && <SelectOptionField label="Select Prefered Currency" isRequired={true} id="currency" defaultValue={selectedCurrency} onChange={(e) => {
                                setErrors([]);
                                setSelectedCurrency(e.target.value)
                            }} options={[ 'USD', 'EUR', "NGN", 'GBP' ]} />}

                            <div className="mt-4 mb-6">
                                <ul>
                                    {(selectedAccount !== '' && selectedAccount  !== 'bank transfer') && <li className="">
                                        <div className="py-1 flex text-xs font-normal justify-between items-center">
                                            <h4 className="font-semibold">Payment Type</h4>
                                            <h4>{selectedAccount.toUpperCase()}</h4>
                                        </div> 
                                        <div className="py-1 flex text-xs font-normal justify-between items-center">
                                            <h4 className="font-semibold">Email</h4>
                                            <h4>{paymentAccounts.accounts[selectedAccount]}</h4>
                                        </div> 
                                    </li>}


                                    {(selectedCurrency !== '' && selectedAccount === 'bank transfer') && <>
                                        {Array.from(Object.values(paymentAccounts.accounts[selectedAccount])).map((ba) => {
                                            return (<li key={ba['name']} className="py-3 border-b border-gray-600">
                                                <div className="py-1 flex text-xs font-normal justify-between items-center">
                                                    <h4 className="font-semibold">Bank Name</h4>
                                                    <h4>{ba['name'].toUpperCase()}</h4>
                                                </div>
                                                <div className="py-1 flex text-xs font-normal justify-between items-center">
                                                    <h4 className="font-semibold">Account Number</h4>
                                                    <h4>{ba[selectedCurrency.toLowerCase()]}</h4>
                                                </div>
                                            </li>);
                                        })}
                                    </>}
                                </ul>
                                
                            </div>

                            <div className="mt-4 mb-4">
                              <FileInput id="reciept" fileType="image/*" onChange={(e) => {
                                setErrors([]);
                                setReciept(e.target.files[0])
                              }} name='reciept' value={reciept} label="Upload Transaction Reciept"  isRequired={true} />
                            </div>
                            <button className="w-full py-2 flex justify-center items center border-2 border-blue-800 text-white font-semibold text-sm bg-blue-800 hover:bg-blue-900 rounded-lg ">
                                <span>
                                    Submit
                                </span>
                            </button>
                        </form>
                    </div>
                    <button onClick={onClose} className="absolute top-4 right-4 text-gray-800 hover:text-red-600">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                            <path fillRule="evenodd" d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z" clipRule="evenodd" />
                        </svg>
                    </button>
                </div>


            </div>
      </div>
  )
}
